export const environment = {
  production: true,
  apiUrl: 'https://socal.de.api.cf.caredirectives.io/api/',
};
